export default [
    'live',
    'indemand',
    'ended',
    'upcoming'
]